import {useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {updateCachedPost} from '../api/posts';
import {useAuth} from '../hooks/useAuth';
import {uploadQueue} from '../lib/uploadQueue';
import {Post} from '../types';

// Gives the upload queue (a plain module) an authenticated fetch and a way into the query
// cache: each uploaded photo is appended to the cached tell at once; when a tell's uploads
// settle the server copy is refetched and the local previews let go.
export default function UploadQueueBridge() {
    const {authedFetch} = useAuth();
    const queryClient = useQueryClient();

    useEffect(() => {
        uploadQueue.wire({
            fetch: authedFetch,
            onUploaded: (postId, photo) => {
                const cached = queryClient.getQueryData<Post>(['posts', postId]);
                if (cached) updateCachedPost(queryClient, {...cached, photos: [...cached.photos.filter(p => p.id !== photo.id), photo]});
            },
            onSettled: postId => {
                void queryClient.invalidateQueries({queryKey: ['posts', postId]}).then(() => uploadQueue.forget(postId));
                void queryClient.invalidateQueries({queryKey: ['posts', 'feed']});
            }
        });
    }, [authedFetch, queryClient]);

    return null;
}
